module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2cn",
    attrs: {
      "id": "ch06"
    }
  }, [_c('strong', [_vm._v("SIX")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2ct"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HANCELLOR")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Four people were supposed to die at sunrise. The council had passed judgment. The high chancellor had looked them each in the eye and informed them of their fate. Beneath the citadel, even deeper than the dungeons, the executioner waited. But by midnight, the only trace of the condemned was four empty cells.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And a single scrap of paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guards had found it in one of the girl’s cells. Cassandra-called-Cassa. The one who thought she was immortal. The chancellor had to admit: She still had not been proven wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("High Chancellor Ansel Dane sat down behind the oak desk in his study, which was warmed by a large hearth. He was as far away from the dank despair of the dungeons and the cold justice of the Judgment Hall as he could be. He’d already ordered the stablemaster to prepare his carriage, but he wasn’t in a hurry. It wouldn’t take long to reach his destination. The chancellor was an old man, less suited than his predecessors to the rigors of his office, but he knew how to play the long game. How else did a nobody from the countryside, the son and grandson of farmers, become a high chancellor of Teruvia?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He unfolded the paper carefully. The parchment was ragged and stained with what he hoped was mud. The ink was blotchy and smeared, penned in a rush, but each word was legible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Vesper—")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("I know it was you. I should have let you burn.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ansel stared in silence for a long while, listening to the crackle and hiss of the fireplace. Finally he stood up, his bones creaking with the effort. He shuffled to the hearth, rested one hand on the mantel to steady himself, and fed the paper to the flames.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1369aee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch06.vue
// module id = 84
// module chunks = 0